import __C from '../primitives/_constant_'
import { FileApi } from './api'

export default class FileService {

  constructor() {
    this.fileApi = new FileApi()
  }

  download(fileId, config={}) {
    return new Promise(resolve => {
      this.fileApi.download(fileId, config).then(res => {
        resolve(res)
      })
    })
  }
  getOptionsList() {
    return new Promise(resolve => {
      this.fileApi.getOptionsList().then(res => {
        let optionsMap = ['lv1', 'lv2', 'lv3', 'area', 'block']
        let res__ = {}

        optionsMap.forEach(k => { 
          if (res[0][k].includes('},]')) resolve({})
          else if (res[0][k]) res__[k] = JSON.parse(res[0][k]) 
        })
    
        resolve(res__)
      })
    })
  }

  getFilterOptionsList() {
    return new Promise(resolve => {
      this.fileApi.getFilterOptionsList().then(res => {
        let optionsMap = ['lv1', 'lv2', 'lv3', 'area', 'block']
        let res__ = {}

        optionsMap.forEach(k => { 
          if (res[0][k].includes('},]')) res[0][k].replace('},]', '}]')
          else if (res[0][k]) res__[k] = JSON.parse(res[0][k]) 
        })
    
        resolve(res__)
      })
    })
  }

  getEditInfo(idx) {
    return new Promise(resolve => {
      this.fileApi.getEditInfo(idx).then(res => {
        resolve(res)
      })
    })
  }
  getConEditInfo(idx) {
    return new Promise(resolve => {
      this.fileApi.getConEditInfo(idx).then(res => {
        resolve(res)
      })
    })
  }
  getFilesFromGallery(params) {
    return new Promise(resolve => {
      this.fileApi.getFilesFromGallery(params).then(res => {
        resolve(res)
      })
    })
  }
  getFilesFromCategory() {
    return new Promise(resolve => {
      this.fileApi.getFilesFromCategory().then(res => {
        resolve(res)
      })
    })
  }
  getFilesFromProduct() {
    return new Promise(resolve => {
      this.fileApi.getFilesFromProduct().then(res => {
        resolve(res)
      })
    })
  }
  putFile2Gallery (file) {
    return new Promise(resolve => {
      this.fileApi.putFile2Gallery(file).then(res => {
        resolve(res)
      })
    })
  }  
  putFile2Category (file) {
    return new Promise(resolve => {
      this.fileApi.putFile2Category(file).then(res => {
        resolve(res)
      })
    })
  }
  putFile2Product (file) {
    return new Promise(resolve => {
      this.fileApi.putFile2CProduct(file).then(res => {
        resolve(res)
      })
    })
  }
  updFile2Gallery (file) {
    return new Promise(resolve => {
      this.fileApi.updFile2Gallery(file).then(res => {
        resolve(res)
      })
    })
  }
  updFile2Category (file) {
    return new Promise(resolve => {
      this.fileApi.updFile2Category(file).then(res => {
        resolve(res)
      })
    })
  }
  delFileFromGallery (idx, fileId) {
    return new Promise(resolve => {
      this.fileApi.delFileFromGallery(idx, fileId).then(res => {
        resolve(res)
      })
    })
  }
  delFileFromCategory (idx, fileId) {
    return new Promise(resolve => {
      this.fileApi.delFileFromCategory(idx, fileId).then(res => {
        resolve(res)
      })
    })
  }
  delFileFromProduct (idx, fileId) {
    return new Promise(resolve => {
      this.fileApi.delFileFromProduct(idx, fileId).then(res => {
        resolve(res)
      })
    })
  }
}